/**
 * @fileOverview  Scroll to top.
 * @author Selectra Front End Team
 * @version 1.0.0
 */

/**
 * Uses requestAnimationFrame to smooth scroll
 */
export default function scrollToTop() {
  // Get scroll state
  let y = window.pageYOffset;

  if ( window.pageYOffset > 0 ) {
    y = y - 100;
    window.scroll( 0, y );
    requestAnimationFrame( scrollToTop );
  }
}
